import React, { useMemo } from 'react';

import useResponsive from '../../hooks/useResponsive';
import { ICustomizations } from '../../store/types/Message.types';

export interface IGiftCustomizingMessageProps {
  customizing: ICustomizations;
}

const GiftCustomizingMessage = ({ customizing }: IGiftCustomizingMessageProps): JSX.Element => {
  const { isMobile } = useResponsive();

  const imageMessageUrl = useMemo(() => {
    if (isMobile) {
      return customizing.mobileMessageImageUrl ? customizing.mobileMessageImageUrl : customizing.messageImageUrl;
    }
    return customizing.messageImageUrl ? customizing.messageImageUrl : customizing.mobileMessageImageUrl;
  }, [customizing, isMobile]);

  return <img width="100%" src={imageMessageUrl || ''} alt="message" />;
};

export default GiftCustomizingMessage;
